<template>
  <div id="app">
    <div v-if="routeLoadingVisible && !loginDialogVisible" class="page-loading"><img :src="loadingLogo" alt="logo"></div>
    <div class="router-main">
      <router-view />
    </div>
    <div id="footer">
      <div class="footer-inner">
        <div class="worktogether"><img alt="workTogether" src="@/assets/images/work_together-0.png"><img
            alt="workTogether" src="@/assets/images/work_together-1.webp"><img alt="workTogether"
            src="@/assets/images/work_together-2.png"><img alt="workTogether"
            src="@/assets/images/work_together-3.png"><img alt="workTogether"
            src="@/assets/images/work_together-4.webp"><img alt="workTogether"
            src="@/assets/images/work_together-5.webp"><img alt="workTogether"
            src="@/assets/images/work_together-6.webp"><img alt="workTogether"
            src="@/assets/images/work_together-7.png"><img alt="workTogether"
            src="@/assets/images/work_together-8.png"><img alt="workTogether"
            src="@/assets/images/work_together-9.webp"></div>
        <div class="other">
          <div class="authentication">
            <div class="item"> <img alt="Sertifikasi Lisensi Malta (MGA)" src="@/assets/images/authentication-0.svg">
              <p>Sertifikasi Lisensi Malta (MGA)</p>
            </div>
            <div class="item"> <img alt="Sertifikasi Kepulauan Virgin Inggris (BVI)"
                src="@/assets/images/authentication-1.svg">
              <p>Sertifikasi Kepulauan Virgin Inggris (BVI)</p>
            </div>
            <div class="item"> <img alt="Dewan Pengawas GC Inggris" src="@/assets/images/authentication-2.svg">
              <p>Dewan Pengawas GC Inggris</p>
            </div>
            <div class="item"> <img alt="Lisensi Pengawasan Filipina (PAGCOR)"
                src="@/assets/images/authentication-3.svg">
              <p>Lisensi Pengawasan Filipina (PAGCOR)</p>
            </div>
          </div>
        </div>
        <!-- <div class="copyright">PIONEER memiliki lisensi legal yang dikeluarkan oleh European Malta MGA, Komisi
          Pengawasan GC Inggris (Komisi Perjudian) dan Pemerintah Filipina (PAGCOR). Terdaftar di Kepulauan Virgin
          Britania Raya, ini adalah perusahaan legal yang diakui oleh asosiasi industri internasional. Pastikan Anda
          berusia minimal 18 tahun sebelum mendaftar dan bersenang-senanglah! <span>Hak Cipta 2019-2021 PIONEER Semua
            Hak Dilindungi Undang-undang</span></div> -->
      </div>
    </div>
    <!-- <div
      class="game-activity-tag"
      @click="gameActivityOpen = true"
    /> -->
    <game-activity-wheel v-model="gameActivityOpen" />
    <login-dialog />
    <login-rules-notify />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GameActivityWheel from '@/components/GameActivityWheel.vue'
import LoginDialog from '@/components/LoginDialog.vue'
import LoginRulesNotify from '@/components/LoginRulesNotify.vue'
import { checkDUser } from '@/api'

export default {
  name: 'App',
  components: {
    GameActivityWheel,
    LoginDialog,
    LoginRulesNotify
  },
  data() {
    return {
      loadingLogo: require('@/assets/images/logo_mobile.png'),
      routeLoadingVisible: false,
      gameActivityOpen: false
    }
  },
  computed: {
    ...mapState(['deviceType']),
    loginDialogVisible() {
      return !!(this.$store.state.user && this.$store.state.user.loginTan)
    },
    isMobile() {
      return this.deviceType === 'MB'
    },
    isPc() {
      return this.deviceType === 'PC'
    }
  },
  created() {
  },
  mounted() {
    this.updateDeviceClass()
    this.$store.dispatch('user/initAuth').catch(() => {})
    this.registerDeviceAfterLoad()
    // this.initLiveChatWidget()
    this.$routeLoadingBus.$on('change', this.handleRouteLoadingChange)
  },
  beforeDestroy() {
    window.removeEventListener('load', this.submitDeviceCode)
    this.$routeLoadingBus.$off('change', this.handleRouteLoadingChange)
  },
  methods: {
    registerDeviceAfterLoad() {
      if (document.readyState === 'complete') {
        this.submitDeviceCode()
        return
      }
      window.addEventListener('load', this.submitDeviceCode, { once: true })
    },
    getOrCreateDeviceCode() {
      const storageKey = 'utkoen'
      const savedCode = localStorage.getItem(storageKey)
      if (savedCode) return savedCode

      let code = ''
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        code = window.crypto.randomUUID().replace(/-/g, '')
      } else if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16)
        window.crypto.getRandomValues(bytes)
        code = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
      } else {
        code = `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`
      }
      localStorage.setItem(storageKey, code)
      return code
    },
    submitDeviceCode() {
      const utkoen = this.getOrCreateDeviceCode()
      checkDUser({ utkoen }).catch(() => {})
    },
    initLiveChatWidget() {
      if (typeof window === 'undefined' || typeof document === 'undefined') return
      if (window.__liveChatInited) return
      window.__liveChatInited = true

      window.__lc = window.__lc || {}
      window.__lc.license = 19635590
      window.__lc.integration_name = 'manual_channels'
      window.__lc.product_name = 'livechat'
      ;(function(n, t, c) {
        function i(args) {
          return e._h ? e._h.apply(null, args) : e._q.push(args)
        }
        var e = {
          _q: [],
          _h: null,
          _v: '2.0',
          on: function() { i(['on', c.call(arguments)]) },
          once: function() { i(['once', c.call(arguments)]) },
          off: function() { i(['off', c.call(arguments)]) },
          get: function() {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.")
            return i(['get', c.call(arguments)])
          },
          call: function() { i(['call', c.call(arguments)]) },
          init: function() {
            var s = t.createElement('script')
            s.async = true
            s.type = 'text/javascript'
            s.src = 'https://cdn.livechatinc.com/tracking.js'
            t.head.appendChild(s)
          }
        }
        if (!n.__lc.asyncInit) e.init()
        n.LiveChatWidget = n.LiveChatWidget || e
      })(window, document, [].slice)
    },
    handleRouteLoadingChange(visible) {
      this.routeLoadingVisible = visible
    },
    getDeviceType() {
      const ua = navigator.userAgent || ''
      const mobileByUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
      const mobileByWidth = window.innerWidth <= 768

      return mobileByUa || mobileByWidth ? 'MB' : 'PC'
    },
    updateDeviceClass() {
      this.$store.commit('setDeviceType', this.getDeviceType())

      document.documentElement.classList.toggle('mobile', this.isMobile)
      document.documentElement.classList.toggle('pc', this.isPc)
      document.documentElement.classList.toggle('theme-style', true)
      document.documentElement.classList.toggle('black-gold-theme', true)
      document.documentElement.classList.remove('champagne-gold-theme')

      document.body.classList.toggle('theme-style', true)
      document.body.classList.toggle('black-gold-theme', true)
      document.body.classList.remove('champagne-gold-theme')

      // Clear inline bg so CSS black-gold gradient takes over
      document.body.style.backgroundImage = ''
      document.body.style.backgroundSize = ''
      document.body.style.backgroundAttachment = ''
      document.body.style.backgroundPosition = ''
      document.body.style.backgroundRepeat = ''
      document.body.style.backgroundColor = ''
    }
  }
}
</script>
<!-- <style src="@/assets/css/index.css"></style> -->
<style>
@import "@/assets/css/index.css";
@import "@/assets/css/index1.css";
@import "@/assets/css/index2.css";
@import "@/assets/css/theme-bosjoko.css";

.page-loading {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.65);
  z-index: 99999;
}

.page-loading img {
  width: 8rem;
  max-width: 40vw;
}

html.mobile body,
html.mobile body.theme-style,
html.mobile body.black-gold-theme {
  margin-bottom: 6.5rem;
}

.black-gold-theme .loginForm,
.black-gold-theme .more-menu-box,
.black-gold-theme .user,
.pc .black-gold-theme .index-footer {
  background-color: #0a0805 !important;
  background-image:
    radial-gradient(ellipse 55% 120% at 12% 50%, rgba(232, 197, 71, 0.18) 0%, transparent 55%),
    linear-gradient(180deg, #1c160c 0%, #100c07 55%, #0a0805 100%) !important;
  box-shadow: inset 0 1px 0 rgba(232, 197, 71, 0.16);
}

.black-gold-theme .tabs {
  background-color: #0a0805 !important;
  background-image:
    radial-gradient(ellipse 55% 120% at 12% 50%, rgba(232, 197, 71, 0.22) 0%, transparent 55%),
    radial-gradient(ellipse 40% 100% at 88% 40%, rgba(240, 213, 106, 0.14) 0%, transparent 50%),
    linear-gradient(180deg, #1c160c 0%, #100c07 55%, #0a0805 100%) !important;
  box-shadow: inset 0 1px 0 rgba(232, 197, 71, 0.22), inset 0 -1px 0 rgba(0, 0, 0, 0.45);
  border-bottom: 1px solid rgba(232, 197, 71, 0.18);
}

.black-gold-theme .tabs .logo,
.black-gold-theme .tabs img.logo,
.black-gold-theme .loginForm .logo {
  background: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  height: 4rem !important;
  width: auto !important;
  max-width: 100%;
  object-fit: contain;
}

.black-gold-theme .mine-menus ul li img,
.black-gold-theme .mine-top .mine-info .about,
.black-gold-theme .user .password:before,
.black-gold-theme .user .username:before {
  filter: brightness(0) saturate(100%) invert(78%) sepia(61%) saturate(650%) hue-rotate(6deg) brightness(102%) contrast(96%) !important;
}

.user .logout-btn:before,
.tabs .tab img:not(.logo),
.theme-style .user.isLogin .nick .nick-img::after,
.tabs .tab.tab-forget:before,
.tabs .tab[data-href="#/forget"]:before {
  filter: brightness(0) saturate(100%) invert(78%) sepia(61%) saturate(650%) hue-rotate(6deg) brightness(102%) contrast(96%) !important;
}

.tabs img.logo,
.tabs .tab.logo,
.loginForm .logo {
  filter: none !important;
}

.pc body.black-gold-theme #index > .tabs,
.pc body.black-gold-theme #index > .tabs.isLogin {
  background-color: #0a0805 !important;
  background-image:
    radial-gradient(ellipse 50% 140% at 10% 50%, rgba(232, 197, 71, 0.28) 0%, transparent 52%),
    radial-gradient(ellipse 35% 120% at 92% 45%, rgba(240, 213, 106, 0.16) 0%, transparent 48%),
    linear-gradient(90deg, #050403 0%, #1a140a 35%, #120e08 65%, #050403 100%),
    linear-gradient(180deg, #221c12 0%, #100c07 50%, #070505 100%) !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-size: 100% 100% !important;
  box-shadow: inset 0 1px 0 rgba(232, 197, 71, 0.28), inset 0 -1px 0 rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid rgba(232, 197, 71, 0.22);
}

.pc body.black-gold-theme #index > .tabs .logo,
.pc body.black-gold-theme #index > .tabs .logo-box {
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
}

@media (hover: hover) and (pointer: fine) {
  /* Avoid body * — custom cursor on every node makes clicks feel laggy */
  html,
  body {
    cursor: url("@/assets/images/cursor-bosjoko.png") 0 0, auto;
  }
}

.pc .theme-style footer .nav-item .icon {
  filter: brightness(0) saturate(100%) invert(78%) sepia(61%) saturate(650%) hue-rotate(6deg) brightness(102%) contrast(96%) !important;
}

footer .nav-item-active {
  background-color: transparent !important;
}
#footer {
  background: linear-gradient(180deg, rgba(10, 8, 5, 0.72) 0%, rgba(7, 5, 5, 0.88) 100%) !important;
  border-top: 1px solid rgba(232, 197, 71, 0.18);
}

/* Ensure API loading stays above all custom popups/masks */
.el-loading-mask.is-fullscreen,
.api-loading-mask.el-loading-mask.is-fullscreen,
.v-modal {
  z-index: 300000 !important;
}
</style>
